import { checkStripe } from "../Common/StripeChecker";
import { Section } from "../jobs-flow/Section";
import { refreshLivewireTree } from "../Common/livewireCompat";

export default{
    init(){
        this.getModal();
        this.createOrUpdatePaymentSubscription();
        this.updateTotalOnForm();
        this.initPagination();
        this.viewDetailsForm();
        this.lifecycleActions();
        this.recoveryActions();
    },

    getModal() {
        let $this=this;
        $(document).on('click', '#new-payment-subscription, .edit_payment_subscription', function(e) {
            e.preventDefault();
            let data = {
                type: $(this).data('type'),
                id: $(this).data('id') ?? null,
            };

            $('.bb-preloader-container').show();

            checkStripe(() => {
                $.ajax({
                    type: 'post',
                    url: '/payment-subscriptions/get-modal',
                    data: data,
                    success: function(response) {
                        $('.modal-container').html(response);
                        $('.bb-preloader-container').hide();
                        $('#create_payment_subscription').modal('show');
                        refreshLivewireTree('#create_payment_subscription');
                        $this.updateTax();
                        $this.changeTaxForServiceListners();
                    },
                    error: function(response) {
                        console.log(response);
                        $('.bb-preloader-container').hide();
                    }
                });
            });
        });
    },

    createOrUpdatePaymentSubscription() {
        $('body').on('click', '#create_payment_subscription .create_payment_subscription', (e) => {
            e.preventDefault();
            //let dataForSend = $('#create-payment-subscription').serializeArray();
            let manual_data = {
                customer_id: $('select[name="customer_id"]').val(),
                service: $('select[name="service"]').val(),
                payment_total: $('#payment_total').val(),
                date_start: $('select[name="date"]').val(),
                frequency:  $('select[name="frequency"]').val(),
                details: $('#comments').val(),
                tax: $('#tax_percent').val() ?? null,
                tax_id: $('#tax_id').val() ?? null,
            };

            this.sendSubscriptionData(manual_data, 'create');
        })

        $('body').on('click', '#create_payment_subscription .update_payment_subscription', (e)=> {
            e.preventDefault();

            let manual_data = {
                id: $('#subscription_id').val(),
                customer_id: $('select[name="customer_id"]').val(),
                service: $('select[name="service"]').val(),
                payment_total: $('#payment_total').val(),
                date_start: $('select[name="date"]').val(),
                frequency:  $('select[name="frequency"]').val(),
                details: $('#comments').val(),
                tax: $('#tax_percent').val() ?? null,
                tax_id: $('#tax_id').val() ?? null,
            };

            this.sendSubscriptionData(manual_data, 'edit');
        });
    },

    sendSubscriptionData(data, type) {
        $('.bb-preloader-container').show();
        $.ajax({
            method: 'POST',
            url: '/payment-subscriptions/'+type+'-payment-subscription',
            data: data,
            success: function(response) {
                window.location.reload(true);
            },
            error: function (response) {
                $('.bb-preloader-container').hide();
                console.log('error:', response);
            }
        });
    },

    updateTotalOnForm() {
        $('body').on('input', '#create_payment_subscription #payment_total', (e) => {
            let value = 0;
            if ($('#payment_total').val()>0) {
                value = parseFloat($('#payment_total').val()) ?? 0;
            }
            $('.sub_total_field').text('$' + value.toFixed(2));

            this.updateTax();
            this.updateTotal();
        });
        $('body').on('change', '#create_payment_subscription #service_tax_check', (e) => {
            let interval = setTimeout(() => this.updateTax(), 150);

        });
        $('body').on('change', '#create_payment_subscription #tax_percent', (e) => {
            if ($(e.target).val() > 0) {
                this.updateTax();
                this.updateTotal();
            }
        });
        /* $('body').on('change', '#create_payment_subscription select[name="tips"]', (e) => {
                $('.tips_total_field').text('$'+parseFloat($(e.target).val()).toFixed(2));
                this.updateTax();
                this.updateTotal();
        }); */

        $('body').on('click', '#create_payment_subscription .apply_tax', ()=> {
            let interval = setTimeout(() => this.updateTax(), 150);
        });

        $('body').on('load', '#create_payment_subscription .custom-checkbox', () => {
            this.updateTax();
            this.updateTotal();
        });
    },

    updateTax(){
        const base = parseFloat($('#create_payment_subscription #payment_total').val());
        const percent = parseFloat($('#tax_percent').val());

        if (base > 0 && percent > 0) {
            // Mirror the server exactly: integer cents x integer basis points,
            // rounded to the cent (PaymentSubscriptionsService::subscriptionComponentsCents).
            // parseInt used to truncate BOTH operands, so a $115.75 base at 8.25%
            // previewed $9.20 while the subscription actually stored $9.55.
            const taxCents = Math.round(Math.round(base * 100) * Math.round(percent * 100) / 10000);
            $('.tax_total_field').text('$' + (taxCents / 100).toFixed(2));
        } else {
            $('.tax_total_field').text('$0.00');
        }
    },

    updateTotal(){
        let final_total = 0;
        if ($('#payment_total').val() >=0) {
            let tax = 0;
            let tips = 0;
            if (!$('.tax_total_field').parent().hasClass('d-none')) {
                tax = parseFloat($('.tax_total_field').text().replace('$',''));
            }
            let sub_total = parseFloat($('.sub_total_field').text().replace('$',''));
            final_total = sub_total + tax;
        }

        $('.final_total_field').text('$'+parseFloat(final_total).toFixed(2));
    },

    initPagination(){
        if (window.location.pathname == '/payment-subscriptions') {
            let section = new Section('payments-subscriptions', true);
            section.show();
        }
    },

    viewDetailsForm(){
        $('body').on('click', '.view_payment_subscriptions_details_btn',(e) => {
            e.preventDefault();
            e.stopPropagation();
            const id = $(e.currentTarget).data('id');
            if (!id) {
                return;
            }

            this.openManagement(id);
        });
    },

    openManagement(id){
        $('.bb-preloader-container').show();
        $.ajax({
            type: 'GET',
            url: `/payment-subscriptions/${id}/details`,
            success: (response) => {
                $('#payment-subscription-management-modal').remove();
                $('body').append(response);
                $('.bb-preloader-container').hide();
                $('#payment-subscription-management-modal').modal('show');
            },
            error: (response) => {
                $('.bb-preloader-container').hide();
                console.error('Unable to load recurring payment management.', response);
            },
        });
    },

    lifecycleActions(){
        $('body').on('click', '.payment-subscription-lifecycle-action', (e) => {
            e.preventDefault();
            const button = $(e.currentTarget);
            const modal = button.closest('#payment-subscription-management-modal');
            const id = modal.data('subscription-id');
            const action = button.data('action');
            const reason = modal.find('#payment-subscription-lifecycle-reason').val().trim();
            const feedback = modal.find('.payment-subscription-action-feedback');

            feedback.addClass('d-none').removeClass('text-danger text-success').text('');
            if (!reason) {
                feedback
                    .removeClass('d-none')
                    .addClass('text-danger')
                    .text('Enter a reason before changing this recurring payment.');
                return;
            }
            if (
                ['end', 'skip_next'].includes(action)
                && !window.confirm(
                    action === 'end'
                        ? 'End this recurring payment? It cannot be resumed.'
                        : 'Skip the next scheduled charge and retain it as canceled history?',
                )
            ) {
                return;
            }

            const buttons = modal.find('.payment-subscription-lifecycle-action');
            buttons.prop('disabled', true);
            $.ajax({
                method: 'POST',
                url: `/payment-subscriptions/${id}/lifecycle`,
                data: {action, reason},
                success: () => {
                    modal.modal('hide');
                    fetchTableData();
                    this.openManagement(id);
                },
                error: (response) => {
                    const errors = response?.responseJSON?.errors || {};
                    const message = Object.values(errors).flat()[0]
                        || response?.responseJSON?.message
                        || 'The recurring payment could not be updated.';
                    feedback
                        .removeClass('d-none')
                        .addClass('text-danger')
                        .text(message);
                    buttons.prop('disabled', false);
                },
            });
        });
    },

    recoveryActions(){
        $('body').on(
            'click',
            '.payment-subscription-recovery-preview-action',
            (e) => {
                e.preventDefault();
                const button = $(e.currentTarget);
                const modal = button.closest(
                    '#payment-subscription-management-modal',
                );
                const subscriptionId = modal.data('subscription-id');
                const occurrenceId = button.data('occurrence-id');
                const action = button.data('action');
                const feedback = button
                    .closest('.payment-subscription-timeline-item')
                    .find('.payment-subscription-recovery-inline-feedback');
                const originalLabel = button.text();

                feedback
                    .addClass('d-none')
                    .removeClass('text-danger')
                    .text('');
                button.prop('disabled', true).text('Loading preview…');
                $.ajax({
                    method: 'POST',
                    url: `/payment-subscriptions/${subscriptionId}/occurrences/${occurrenceId}/recovery-preview`,
                    data: {action},
                    success: (response) => {
                        this.showRecoveryPreview(
                            modal,
                            response.preview,
                        );
                    },
                    error: (response) => {
                        feedback
                            .removeClass('d-none')
                            .addClass('text-danger')
                            .text(this.responseMessage(
                                response,
                                'The recovery preview could not be created.',
                            ));
                    },
                    complete: () => {
                        button.prop('disabled', false).text(originalLabel);
                    },
                });
            },
        );

        $('body').on(
            'click',
            '.payment-subscription-recovery-apply',
            (e) => {
                e.preventDefault();
                const button = $(e.currentTarget);
                const panel = button.closest(
                    '.payment-subscription-recovery-preview',
                );
                const modal = panel.closest(
                    '#payment-subscription-management-modal',
                );
                const action = panel.data('action');
                const occurrenceId = panel.data('occurrence-id');
                const previewToken = panel.data('preview-token');
                const subscriptionId = modal.data('subscription-id');
                const feedback = panel.find(
                    '.payment-subscription-recovery-feedback',
                );

                if (!action || !occurrenceId || !previewToken) {
                    feedback
                        .removeClass('d-none')
                        .addClass('text-danger')
                        .text('Preview this recovery again before applying it.');
                    return;
                }

                const confirmation = action === 'retry'
                    ? 'Apply this retry? This can create a new payment attempt and contact the payment provider.'
                    : 'Apply this reconciliation? This will retrieve the existing provider intent; it will not create a new charge.';
                if (!window.confirm(confirmation)) {
                    return;
                }

                const controls = panel.find('button');
                controls.prop('disabled', true);
                button.text(
                    action === 'retry'
                        ? 'Applying retry…'
                        : 'Reconciling…',
                );
                feedback
                    .addClass('d-none')
                    .removeClass('text-danger text-success')
                    .text('');
                $.ajax({
                    method: 'POST',
                    url: `/payment-subscriptions/${subscriptionId}/occurrences/${occurrenceId}/recovery-apply`,
                    data: {
                        action,
                        preview_token: previewToken,
                        confirmed: true,
                    },
                    success: (response) => {
                        feedback
                            .removeClass('d-none')
                            .addClass('text-success')
                            .text(response.message);
                        modal.modal('hide');
                        fetchTableData();
                        this.openManagement(subscriptionId);
                    },
                    error: (response) => {
                        panel
                            .removeData('preview-token')
                            .removeData('action')
                            .removeData('occurrence-id');
                        button
                            .prop('disabled', true)
                            .text('Preview again to apply');
                        panel
                            .find('.payment-subscription-recovery-cancel')
                            .prop('disabled', false);
                        feedback
                            .removeClass('d-none')
                            .addClass('text-danger')
                            .text(this.responseMessage(
                                response,
                                'The recovery could not be applied. Preview the current charge state again.',
                            ));
                    },
                });
            },
        );

        $('body').on(
            'click',
            '.payment-subscription-recovery-cancel',
            (e) => {
                e.preventDefault();
                this.resetRecoveryPreview(
                    $(e.currentTarget).closest(
                        '.payment-subscription-recovery-preview',
                    ),
                );
            },
        );
    },

    showRecoveryPreview(modal, preview){
        const panel = modal.find(
            '.payment-subscription-recovery-preview',
        );
        const retry = preview.action === 'retry';
        const operation = retry
            ? `Create payment attempt ${preview.operation.next_attempt_number}`
            : `Retrieve ${preview.operation.provider || 'provider'} attempt ${preview.operation.attempt_id}`;

        panel
            .data('action', preview.action)
            .data('occurrence-id', preview.occurrence.id)
            .data('preview-token', preview.preview_token)
            .removeClass('d-none');
        panel.find('[data-recovery-charge]').text(
            `#${preview.occurrence.number} · due ${preview.occurrence.due_on}`,
        );
        panel.find('[data-recovery-status]').text(
            `${preview.occurrence.status.replace(/_/g, ' ')} · ${preview.occurrence.attempt_count} attempts`,
        );
        panel.find('[data-recovery-operation]').text(operation);
        panel.find('[data-recovery-provider]').text(
            retry
                ? 'The normal payment processor may create and submit a new charge attempt.'
                : 'Reads the existing provider intent; no new charge is created.',
        );
        panel.find('[data-recovery-warning]').text(
            retry
                ? 'Applying this preview may charge the customer. Cancel if you have not verified the failure and payment method.'
                : 'Applying this preview can change the local charge status to match the provider.',
        );
        panel
            .find('.payment-subscription-recovery-apply')
            .prop('disabled', false)
            .text(retry ? 'Apply retry' : 'Apply reconciliation');
        panel
            .find('.payment-subscription-recovery-cancel')
            .prop('disabled', false);
        panel
            .find('.payment-subscription-recovery-feedback')
            .addClass('d-none')
            .removeClass('text-danger text-success')
            .text('');
        panel[0]?.scrollIntoView({behavior: 'smooth', block: 'nearest'});
    },

    resetRecoveryPreview(panel){
        panel
            .removeData('preview-token')
            .removeData('action')
            .removeData('occurrence-id')
            .addClass('d-none');
        panel.find('[data-recovery-charge], [data-recovery-status], [data-recovery-operation], [data-recovery-provider], [data-recovery-warning]').text('');
        panel
            .find('.payment-subscription-recovery-feedback')
            .addClass('d-none')
            .removeClass('text-danger text-success')
            .text('');
    },

    responseMessage(response, fallback){
        const errors = response?.responseJSON?.errors || {};
        return Object.values(errors).flat()[0]
            || response?.responseJSON?.message
            || fallback;
    },

    changeTaxForServiceListners(){
        $('select[name="service"]').off();
        $('select[name="service"]').on('change', (e)=>{
            this.getDataForService($(e.target).val());
        });
    },

    getDataForService(service_id){
        $.ajax({
            method: 'POST',
            url: `/payment-subscriptions/${service_id}/get-tax`,
            success: (response)=>{
                this.updateFormOnNewData(response);
            },
            error: (response) =>{
                console.log(response);
            }
        });
    },

    updateFormOnNewData(data){
        if (data.requires_payment) {
            $('.sub_total_field').parent().removeClass('d-none');
            if (!data.tax_exempt) {
                if (data.tax && data.tax.percent) {
                    $('#tax_percent').val(data.tax.percent);
                    $('.tax_total_field').parent().removeClass('d-none');
                }
            }else{
                $('.tax_total_field').parent().addClass('d-none');
                $('#tax_percent').val('');
            }
            this.updateTax();
        }else{
            $('.sub_total_field').parent().addClass('d-none');
            $('.tax_total_field').parent().addClass('d-none');
            $('#tax_percent').val('');
        }
        this.updateTotal();
    }
}
